/**
 * Вертикаль-специфичные UI-тексты страницы страховки (InsurancePageContent).
 * Общие строки сервис-страниц — в sections/servicePage.js (ns `servicePage`).
 */
export const insurancePage = {
    en: {
        leaf: 'Insurance',
        whyEyebrow: 'Why insurance',
        whyTitle: 'Why you need insurance',
        benefitsTitle: 'Benefits',
        instructionTitle: 'How to get covered',
        heroChoose: 'Choose insurance',
        heroHow: 'How it works',
        aboutAnchor: 'About',
        providersTitle: 'Insurance providers',
        promosTitle: 'Insurance promo codes',
        promoLead: 'Current insurer discounts — tap “Show code” to copy.',
        articlesTitle: 'Insurance articles',
        articlesLead: 'What insurance covers, how to choose a policy and avoid overpaying.',
        ctaEyebrow: 'Travel with peace of mind',
        ctaTitle: (to) => `Insure your trip${to ? ` to ${to}` : ''}.`,
        ctaBtn: 'Choose insurance →',
    },
    ru: {
        leaf: 'Страховка',
        whyEyebrow: 'Для чего',
        whyTitle: 'Зачем нужна страховка',
        benefitsTitle: 'Преимущества',
        instructionTitle: 'Как оформить',
        heroChoose: 'Выбрать страховку',
        heroHow: 'Как оформить',
        aboutAnchor: 'О страховке',
        providersTitle: 'Страховые провайдеры',
        promosTitle: 'Промокоды на страховку',
        promoLead: 'Актуальные скидки от страховых — нажмите «Показать код», чтобы скопировать.',
        articlesTitle: 'Статьи о страховке',
        articlesLead: 'Что покрывает страховка, как выбрать полис и не переплатить.',
        ctaEyebrow: 'Спокойная поездка',
        ctaTitle: (to) => `Застрахуйте поездку${to ? ` в ${to}` : ''}.`,
        ctaBtn: 'Выбрать страховку →',
    },
};
